// Where a CRM environment may post its session token after login. The token is a live CRM session,
// so a target is accepted only on a full match — scheme, host, port and path — for the environment
// the CRM is running in. Anything else is ignored and the user stays in the CRM.
const CALLBACK_PATH = "/api/crm-callback";

const isLocalhostCallback = (target) =>
    target.protocol === "http:" && target.hostname === "localhost" && target.port !== "";

const isAllowedCallback = (target, crmHostname) => {
    if (target.pathname !== CALLBACK_PATH || target.search || target.hash || target.username || target.password) {
        return false;
    }

    if (crmHostname === "crm.popleads.com") {
        return target.origin === "https://www.leoron.com";
    }

    const devCrm = /^dev-crm-(\d+)\.popleads\.com$/.exec(crmHostname);
    if (devCrm) {
        return target.origin === `https://dev-ecommerce-${devCrm[1]}.popleads.com` || isLocalhostCallback(target);
    }

    if (crmHostname === "localhost") {
        return isLocalhostCallback(target);
    }

    return false;
};

// Returns the normalised callback URL when `url` is allowed for this CRM environment, otherwise null.
export const getCallbackTarget = (url, crmHostname = window.location.hostname) => {
    if (!url) return null;
    let target;
    try {
        target = new URL(url);
    } catch {
        return null;
    }
    return isAllowedCallback(target, crmHostname) ? target.href : null;
};

// A real form submit rather than a navigation, so the token travels in the request body and never in the URL.
export const postTokenToCallback = (href, token, state) => {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = href;
    form.enctype = "application/x-www-form-urlencoded";
    form.style.display = "none";

    const fields = state === null ? { token } : { token, state };
    Object.entries(fields).forEach(([name, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
};
